import { createIcon } from '../../createIcon';
import { withIcon } from '../../withIcon';
import { FullscreenSvg } from './Fullscreen';

export const FullscreenIcon = createIcon('fullscreen', FullscreenSvg);
/**
 * @deprecated используйте FullscreenIcon
 */
export const withFullscreenIcon = withIcon('fullscreen', FullscreenSvg);
